var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/lock-keyhole"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 10H18.5C19.6046 10 20.5 10.8954 20.5 12V19.5C20.5 20.6046 19.6046 21.5 18.5 21.5H5.5C4.39543 21.5 3.5 20.6046 3.5 19.5V12C3.5 10.8954 4.39543 10 5.5 10Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 10V7C7.5 5.80653 7.97411 4.66193 8.81802 3.81802C9.66193 2.97411 10.8065 2.5 12 2.5C13.1935 2.5 14.3381 2.97411 15.182 3.81802C16.0259 4.66193 16.5 5.80653 16.5 7V10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3 15.2C13.3 15.918 12.718 16.5 12 16.5C11.282 16.5 10.7 15.918 10.7 15.2C10.7 14.482 11.282 13.9 12 13.9C12.718 13.9 13.3 14.482 13.3 15.2Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 16.5V18.3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e03a29a99dabb4d04d723b6ecac80ab4.svg";
export { ForwardRef as ReactComponent };